import * as actions from '../actions/overlay';

export default function reducer(state, action) {
  switch (action.type) {
    case actions.OVERLAY_OPENED:
      if (state === action.overlay) {
        return state;
      }

      return action.overlay;

    case actions.OVERLAY_CLOSED:
      return null;

    default:
      throw new Error(`Unknown overlay action: ${action.type}`);
  }
}
